import React from 'react';
import { CampaignCardSkeleton } from '../../../campaign-card/CampaignCardSkeleton';
import { CampaignCardsFeedProps } from '../../campaign-cards-feed-props';

export function CampaignCardsFeedGridSkeleton(arg: {
  props: CampaignCardsFeedProps;
  animated?: boolean;
}) {
  const { animated = true } = arg;
  const { nbColumns = 3, nbRows = 1 } = arg.props;
  const skeletons = Array.from({ length: nbColumns * nbRows });

  return (
    <div
      className="campaign-cards-grid qlf-skeleton"
      style={{
        display: 'grid',
        gap: '1rem',
        alignItems: 'stretch',
        gridTemplateColumns: `repeat(${nbColumns}, minmax(0, 1fr))`,
        flexGrow: 1,
        flex: 1,
        width: '100%',
      }}
    >
      {skeletons.map((_, index) => (
        <CampaignCardSkeleton key={index} animated={animated} />
      ))}
    </div>
  );
}
